<template>
  <head>
    <meta http-equiv="Content-Type" content="text/html; charset=UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1">
    <title>Demand Notice</title>
    <link rel="shortcut icon" href="images/favicon.png" type="image/x-icon">
    <link rel="preconnect" href="https://fonts.googleapis.com">
    <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
    <link href="https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap" rel="stylesheet">
    <link rel="preconnect" href="https://fonts.googleapis.com">
    <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
    <link href="https://fonts.googleapis.com/css2?family=Yellowtail&display=swap" rel="stylesheet">
  </head>

  <body style="padding: 0px; margin: 0px; font-family: 'Montserrat', sans-serif; background-color: #a2a2a21c;box-sizing: border-box;">

  <button class="print-btn" onclick="window.print()"><img src="assets/printer.svg" alt="Printer Icon"></button>
  <button class="print-btn email-doc" title="send On Email"><img src="assets/email-icon.png" alt="Printer Icon "></button>

  <page class="page" style="width: 210mm; height:297mm; display: flex; position: relative; flex-flow: column; background-color: white;">
    <!-- main content -->
    <div style="padding: 8.5mm;">

      <header style="display: flex; height: 47mm; align-items: center; position: relative; width: 100%; justify-content: space-between;">
        <div>
          <img :src="state_logo()" style="height: 36mm; margin-right: 0mm;">
        </div>
        <div style="text-align: center; margin-right: 8.5mm; margin-left: 8.5mm;">
          <h2 style="
                        margin-top: 0px;
                        font-size: 26px;
                        text-transform: uppercase;
                        color: #4ca82c;
                        font-weight: 700;
                        margin-bottom: 1.2mm;
                        padding-bottom: 0px;
                    ">
            County Government <br> {{county.countyName}}
          </h2>

          <h4 style="padding: 0px;
                    margin: 0px;
                    font-size: 18px;
                    font-weight: bold; text-transform: uppercase; margin-bottom: 0;">
            Demand Notice
          </h4>

          <h4 style="padding: 0px;
                    margin: 0px;
                    font-size: 13px;
                    font-weight: 400; font-style: italic; font-family: 'Times New Roman', Times, serif; margin-top: 0mm; margin-bottom: 4.5mm;">
            <span style="font-style: italic; font-family: 'Times New Roman', Times, serif; margin-right: 3mm;">The Rating Act (CAP 267)</span>
          </h4>

          <h4 style="padding: 0px;
                    margin: 0px;
                    font-size: 14px;
                    font-weight: 400;">
            {{county.address}} <br>
            Email: {{county.email}}
          </h4>

          <h4 style="padding: 0px;
                    margin: 0px;
                    font-size: 13px;
                    font-weight: 400; font-style: italic; font-family: 'Times New Roman', Times, serif; margin-top: 2mm; line-height: 1.4;">
            <span style="font-style: italic; font-family: 'Times New Roman', Times, serif; display: block; margin-bottom: 1mm;">{{county.tagline}}</span>
            <span style="font-style: italic; font-family: 'Times New Roman', Times, serif; display: block;">#{{county.tagline2}}</span>
          </h4>
        </div>
        <div>
          <img :src="county_logo()" style="height: 36mm; margin-right: 0mm;">
        </div>
      </header>

      <div>
        <img src="./assets/red-line.png" style="width: 100%;">
      </div>

      <!-- contact information and QR code -->
      <div style="display: flex; justify-content: space-between;">
        <!-- contact information -->
        <div style="font-size: 12px; margin-top: 1.5mm;">
          <p style="padding: 0px; margin: 0px; padding-top: 0mm; padding-bottom: 1.5mm; margin-top:0.05mm;">Printed By <strong style="text-transform:uppercase;">{{sessionNames}}</strong></p>
          <p style="padding: 0px; margin: 0px; padding-top: 0mm; padding-bottom: 1.5mm; margin-top:1.5mm;">Date Printed <strong style="text-transform:uppercase;">{{formatDate(showDate())}}</strong></p>
        </div>
      </div>

      <!-- the property information table -->
      <table style="margin-top:6.3mm; border-spacing: initial; width: 100%;">
        <thead class="" style="text-transform: uppercase;
                font-weight: 700;
                font-size: 12px;
                background: #9e9e9e2e;
                padding: 2.5mm;">
        <tr>
          <td colspan="3" style="padding: 2.5mm;">Notice Date: {{formatDate(property.dateCreated)}}</td>
        </tr>
        </thead>
        <tbody style="font-size: 12px; text-transform: uppercase; text-wrap: nowrap;">
        <tr>
          <td>
            <span>UPN NO.: </span>
            <strong>{{property.UPN || 'N/A'}}</strong>
          </td>
          <td>
            <span>Block No.: </span>
            <strong>{{property.block || 'N/A'}}</strong>
          </td>
          <td>
            <span>Plot/LR No.: </span>
            <strong>{{property.LRNumber}}</strong>
          </td>
        </tr>

        <tr>
          <td>
            <span>Sub County: </span>
            <strong>{{property.subCountyName}}</strong>
          </td>
          <td>
            <span>Ward: </span>
            <strong>{{property.wardName || 'N/A'}}</strong>
          </td>
          <td>
            <span>Zone/Market: </span>
            <strong>{{property.zone || 'N/A'}}</strong>
          </td>
        </tr>

        <tr>
          <td colspan="2">
            <span>Rate Payer: </span>
            <strong>{{property.ownerNames}}</strong>
          </td>
          <td>
            <span>Status: </span>
            <strong>{{property.status}}</strong>
          </td>
        </tr>

        <tr>
          <td colspan="3">
            <span>Physical Address: </span>
            <strong>{{property.percelAddress || 'Not Provided'}}</strong>
          </td>
        </tr>

        <tr v-if="property.percelSize && parseFloat(property.percelSize) > 0">
          <td>
            <span>Parcel Size: </span>
            <strong>{{numberFormat(property.percelSize)}} Ha</strong>
          </td>
          <td>
            <span>Land Use: </span>
            <strong>{{property.useName || 'Not Set'}}</strong>
          </td>
          <td>
            <span>Annual Total: </span>
            <strong>KES {{numberFormat(getTotalAnnualCharges())}}</strong>
          </td>
        </tr>
        </tbody>
      </table>

      <div>
        <img src="./assets/red-line.png" style="width: 100%; margin-bottom: 0mm;">
      </div>

      <!-- billing details and summary -->
      <div style="display: flex; position: relative; margin-top: 3.3mm;">

        <!-- Stamp positioned absolutely to avoid overlapping -->
        <div style="position: absolute; left: -5mm; top: 10mm; z-index: 1;">
          <img src="./assets/demand-notice-stamp.png" style="height: 30mm; transform: rotate(45deg); opacity: 0.6;">
        </div>

        <!-- Table with proper margin to avoid stamp overlap -->
        <div style="width: 100%; margin-left: 40mm;">
          <table style="border-spacing: 0; text-transform: capitalize; font-size: 12px; width: 100%;">
            <thead style="text-transform: uppercase;
                            font-weight: 700;
                            font-size: 12px;
                            background: #9e9e9e2e;
                            padding: 2.5mm;">
            <tr>
              <td colspan="4" style="padding: 2.5mm; text-align: center; border: 1px solid #d9d9d9;">Details Of Charges</td>
            </tr>
            </thead>
            <tbody>
            <!-- Annual Charges Row -->
            <tr style="background: #e8f5e8;">
              <td style="padding: 2.5mm; border: 1px solid #d9d9d9; width: 35%; font-weight: bold;">Annual Land Rates</td>
              <td style="text-align: right; padding: 2.5mm; border: 1px solid #d9d9d9; font-weight: bold; width: 15%; color: #28a745;">KES {{numberFormat(parseFloat(property.annualLandRates) || 0)}}</td>
              <td style="padding: 2.5mm; border: 1px solid #d9d9d9; width: 35%; font-weight: bold;">Annual Ground Rent</td>
              <td style="text-align: right; padding: 2.5mm; border: 1px solid #d9d9d9; font-weight: bold; width: 15%; color: #17a2b8;">KES {{numberFormat(parseFloat(property.annualGroundRent) || 0)}}</td>
            </tr>

            <!-- Arrears Row -->
            <tr style="background: #fff3cd;">
              <td style="padding: 2.5mm; border: 1px solid #d9d9d9;">Land Rates Arrears</td>
              <td style="text-align: right; padding: 2.5mm; border: 1px solid #d9d9d9; font-weight: bold; color: #856404;">KES {{numberFormat(parseFloat(property.landRatesArrears) || 0)}}</td>
              <td style="padding: 2.5mm; border: 1px solid #d9d9d9;">Ground Rent Arrears</td>
              <td style="text-align: right; padding: 2.5mm; border: 1px solid #d9d9d9; font-weight: bold; color: #856404;">KES {{numberFormat(parseFloat(property.groundRentArrears) || 0)}}</td>
            </tr>

            <!-- Penalties and Interest Row -->
            <tr style="background: #f8d7da;">
              <td style="padding: 2.5mm; border: 1px solid #d9d9d9;">Accumulated Penalty</td>
              <td style="text-align: right; padding: 2.5mm; border: 1px solid #d9d9d9; font-weight: bold; color: #721c24;">KES {{numberFormat(parseFloat(property.accumPenalty) || 0)}}</td>
              <td style="padding: 2.5mm; border: 1px solid #d9d9d9;">Accumulated Interest</td>
              <td style="text-align: right; padding: 2.5mm; border: 1px solid #d9d9d9; font-weight: bold; color: #721c24;">KES {{numberFormat(parseFloat(property.accumInterest) || 0)}}</td>
            </tr>

            <!-- Payments and Balance Row -->
            <tr style="background: #d1ecf1;">
              <td style="padding: 2.5mm; border: 1px solid #d9d9d9;">Total Payments Made</td>
              <td style="text-align: right; padding: 2.5mm; border: 1px solid #d9d9d9; font-weight: bold; color: #0c5460;">KES {{numberFormat(parseFloat(property.payments) || 0)}}</td>
              <td style="padding: 2.5mm; border: 1px solid #d9d9d9;">Outstanding Balance</td>
              <td style="text-align: right; padding: 2.5mm; border: 1px solid #d9d9d9; font-weight: bold; color: #721c24;">KES {{numberFormat(parseFloat(property.outstandingArrears) || 0)}}</td>
            </tr>

            <!-- Total Amount Due Row -->
            <tr style="background: #343a40; color: white;">
              <td style="padding: 2.5mm; font-weight: bold; border: 1px solid #d9d9d9; color: white;">TOTAL AMOUNT DUE:</td>
              <td colspan="3" style="text-align: right; padding: 2.5mm; color: #ffeb3b; font-weight: bold; font-size: 16px; border: 1px solid #d9d9d9;">KES {{numberFormat(getCurrentBalance())}}</td>
            </tr>
            </tbody>
          </table>

          <!-- Payment Priority Information -->
          <div style="margin-top: 5mm; padding: 3mm; background: #e3f2fd; border: 1px solid #2196f3; border-radius: 3px;">
            <h6 style="margin: 0 0 2mm 0; font-size: 11px; color: #1565c0; font-weight: bold;">PAYMENT PRIORITY (Per BRD Guidelines):</h6>
            <ol style="margin: 0; padding-left: 4mm; font-size: 10px; color: #0d47a1;">
              <li style="margin-bottom: 1mm;"><strong>Interest:</strong> KES {{numberFormat(parseFloat(property.accumInterest) || 0)}}</li>
              <li style="margin-bottom: 1mm;"><strong>Penalty:</strong> KES {{numberFormat(parseFloat(property.accumPenalty) || 0)}}</li>
              <li style="margin-bottom: 1mm;"><strong>Land Rates Principal:</strong> KES {{numberFormat(parseFloat(property.landRatesArrears) || 0)}}</li>
              <li style="margin-bottom: 0;"><strong>Ground Rent Principal:</strong> KES {{numberFormat(parseFloat(property.groundRentArrears) || 0)}}</li>
            </ol>
          </div>
        </div>
      </div>
    </div>

    <!-- the footer starts here -->
    <div style="padding: 8.5mm;width: 100%;background-color: #9e9e9e2e;flex-grow: 1;margin-top: 0mm;display: flex;flex-flow: column;align-items: baseline;justify-content: space-between;">
      <div style="display: flex;justify-content: space-between;width: 100%;">

        <div style="font-size: 12px;padding-top:3.3mm;">
          <h2 style="
                        margin-top: 0px;
                        font-size: 18px;
                        text-transform: uppercase;
                        color: #0045a1;
                        font-weight: 700;
                        margin-bottom: 3.3mm;
                        padding-bottom: 0px;
                        text-transform: uppercase;
                    ">
            Please note that the outstanding amount is
          </h2>
          <ol class="">
            <li style="margin-bottom: 2.5mm;">Payable at the county cash office or by other electronic means clearly outlined by the county</li>
            <li style="margin-bottom: 2.5mm;">The total amount will continue to accrue a late payment penalty at the stipulated rate.</li>
            <li style="margin-bottom: 2.5mm;">Payment allocation follows BRD priority: Interest → Penalty → Land Rates → Ground Rent</li>
          </ol>

          <p><strong>Please contact the customer service at county offices for any queries.</strong></p>
        </div>

        <!-- QR code for payment -->
        <div style="padding-top:3.3mm;padding-left: 17.3mm; margin-bottom: 12mm;">
          <div style="display: flex; margin-bottom: 4mm; justify-content: flex-end; align-items: center;">
            <span style="font-family: 'Yellowtail', cursive; color: #4ca82c; line-height: 0.9; font-size: 24px; text-align: right; transform: rotate(37deg);">Scan to Pay  <br>Instantly!</span>
          </div>

          <div style="position: relative; display: flex;">
            <img :src="generateQRCode()" style="height: 22mm; margin: 1.25mm;">
            <img src="assets/camera-frame.svg" style="
                        position: absolute;
                        left: 0;
                        height: 24mm;
                    ">
            <img src="assets/curved-arrow.svg" style="
                        height: 11mm;
                        margin-left: 0mm;
                        margin-top: 12px;
                    ">
          </div>
        </div>
      </div>

      <footer style="position: relative; width: 100%;">
        <div style="position: absolute; bottom: 0mm;">
          <div style="display: flex; flex-flow: column;">
            <span style="font-family: 'Yellowtail', cursive; color: #0045a1; line-height: 0.9; font-size: 20px; text-align: right;">Thank You!</span>
            <img src="assets/blue-line.png" style="width: 100%;">
          </div>

          <!-- Legal Disclaimer -->
          <div style="width: 100%; margin-bottom: 3mm;">
            <div style="
              background-color: #ffffff;
              border: 2px solid #0045a1;
              padding: 3mm;
              border-radius: 5px;
              box-shadow: 0 2px 4px rgba(0,0,0,0.1);
            ">
              <p style="
                margin: 0;
                font-size: 11px;
                font-style: italic;
                color: #0045a1;
                text-align: center;
                line-height: 1.4;
                font-weight: 600;
                text-transform: uppercase;
                letter-spacing: 0.3px;
              ">
                <strong>DISCLAIMER:</strong> This Demand Notice shall not be taken as evidence of ownership, title, or any proprietary interest in the land.
              </p>
            </div>
          </div>

          <div style="display: flex; align-items: center; justify-content: space-between; margin-top: 2mm;">
            <p style="padding-bottom: 10px;margin-bottom:0px;font-size: 12px;margin-top: 0mm;">Prepared By <strong>{{property.createdBy}}</strong></p>
            <p style="padding-bottom:10px; margin-bottom:0px;font-size: 12px;margin-top: 0mm; text-transform: uppercase;"><strong>Property ID: {{property.id}}</strong></p>
            <div style="position: absolut; display: flex; align-items: center; justify-content: center; font-size: 12px; margin-left: 8.5mm;">
              <p style="font-weight: bold;">Powered By</p>
              <img :src="county_logo()" style="height: 10mm; padding-left: 2.5mm;">
            </div>
          </div>
        </div>
      </footer>
    </div>
  </page>
  </body>
</template>

<script>
/* eslint-disable */

import {execute, landRate, state_logo, county_logo} from "@/api";
import dayjs from 'dayjs';

export default {
  name: "DemandNotice",
  data() {
    return {
      sessionNames: "",
      date: null,
      county: {
        countyName: null,
        address: null,
        email: null,
        tagline: null,
        tagline2: null
      },
      property: {
        id: null,
        UPN: null,
        LRNumber: null,
        subCountyName: null,
        wardName: null,
        zone: null,
        block: null,
        ownerNames: null,
        percelAddress: null,
        percelSize: null,
        useName: null,
        status: null,
        annualLandRates: 0,
        annualGroundRent: 0,
        landRatesArrears: 0,
        groundRentArrears: 0,
        accumPenalty: 0,
        accumInterest: 0,
        payments: 0,
        currentBalance: 0,
        outstandingArrears: 0,
        createdBy: null,
        dateCreated: null
      }
    };
  },
  mounted() {
    this.sessionNames = sessionStorage.getItem("sessionNames") || "System User";

    // Get the property ID from URL or localStorage
    const hash = window.location.hash;
    const propertyIdFromURL = hash.split('/')[3];

    if (propertyIdFromURL) {
      this.getPropertyForDemandNotice(propertyIdFromURL);
    } else {
      // Check localStorage for params
      try {
        const params = JSON.parse(localStorage['params']);
        if (params.propertyId) {
          this.getPropertyForDemandNotice(params.propertyId);
        } else {
          alert("No property ID provided");
        }
      } catch (error) {
        alert("No property information found");
      }
    }

    this.menuAccess();
  },
  methods: {
    state_logo() {
      return state_logo;
    },
    county_logo() {
      return county_logo;
    },

    menuAccess() {
      const data = new FormData();
      data.append("function", "menuAccess");
      data.append("menu", "Demand Notice");
      data.append("sessionNames", sessionStorage.getItem("sessionNames"));
      data.append("sessionIdNo", sessionStorage.getItem("sessionIdNo"));
      execute(data, landRate)
          .then(() => {
            // Menu access logged
          })
          .catch(() => {
            // Handle error silently
          });
    },

    numberFormat(num) {
      if (num === null || num === undefined || isNaN(num)) {
        return '0';
      }
      const britishNumberFormatter = new Intl.NumberFormat("en-GB");
      return britishNumberFormatter.format(parseFloat(num));
    },

    formatDate(dateString) {
      if (!dateString) return dayjs().format('DD MMM YYYY [AT] hh:mm A');
      const date = dayjs(dateString);
      return date.format('DD MMM YYYY [AT] hh:mm A');
    },

    showDate() {
      return new Date();
    },

    getTotalAnnualCharges() {
      const landRates = parseFloat(this.property.annualLandRates) || 0;
      const groundRent = parseFloat(this.property.annualGroundRent) || 0;
      return landRates + groundRent;
    },

    getCurrentBalance() {
      // Use currentBalance if available, otherwise calculate or use outstandingArrears
      if (this.property.currentBalance && parseFloat(this.property.currentBalance) > 0) {
        return parseFloat(this.property.currentBalance);
      }

      // If currentBalance is not available, calculate total due
      const landRatesArrears = parseFloat(this.property.landRatesArrears) || 0;
      const groundRentArrears = parseFloat(this.property.groundRentArrears) || 0;
      const penalty = parseFloat(this.property.accumPenalty) || 0;
      const interest = parseFloat(this.property.accumInterest) || 0;
      const payments = parseFloat(this.property.payments) || 0;

      const totalDue = landRatesArrears + groundRentArrears + penalty + interest - payments;

      return totalDue > 0 ? totalDue : (parseFloat(this.property.outstandingArrears) || 0);
    },

    generateQRCode() {
      const amount = this.getCurrentBalance();
      const propertyRef = this.property.LRNumber || this.property.id;

      // Generate QR code for M-Pesa or bank payment
      const qrData = `Property: ${propertyRef} | Owner: ${this.property.ownerNames} | Amount: KES ${this.numberFormat(amount)}`;
      return `https://api.qrserver.com/v1/create-qr-code/?size=300x300&data=${encodeURIComponent(qrData)}`;
    },

    getPropertyForDemandNotice(propertyId) {
      const data = new FormData();
      data.append("function", "getPropertyForDemandNotice");
      data.append("propertyId", propertyId);

      execute(data, landRate)
          .then((res) => {
            if (res.data.success) {
              this.property = res.data.data.property;
              this.county = res.data.data.county || this.county;

              console.log('Property loaded:', this.property);
            } else {
              alert("Error loading property: " + res.data.message);
            }
          })
          .catch((e) => {
            console.error('Error fetching property:', e);
            alert("Error loading property data: " + e.message);
          });
    }
  }
};
</script>

<style scoped>
* {
  box-sizing: border-box;
  font-family: 'Montserrat', sans-serif;
  -webkit-print-color-adjust: exact !important;
  color-adjust: exact !important;
}

.print-btn {
  display: flex;
  z-index: 1000000000;
  position: fixed;
  background: #4aaa23;
  color: white;
  top: 30px;
  right: 30px;
  border-radius: 50%;
  padding: 1rem;
  margin: 0px;
  border: none;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 1px 0px 20px 4px rgb(136 136 136 / 65%);
  cursor: pointer;
  transition: 0.4s;
}

.email-doc {
  top: 130px;
  background: #0063c0;
}

.print-btn img {
  height: 35px;
}

@media print {
  .print-btn {
    display: none;
  }
  body {
    margin: 0px !important;
    padding: 0px !important;
    background-color: white;
  }
  @page {
    size: A4 portrait;
    margin: 0px;
  }
}

td {
  padding: 15px;
  border: 1px solid #00000014;
}

/* Enhanced styling for better visual distinction */
.annual-charges {
  background-color: #e8f5e8 !important;
}

.arrears-charges {
  background-color: #fff3cd !important;
}

.penalty-charges {
  background-color: #f8d7da !important;
}

.payment-info {
  background-color: #d1ecf1 !important;
}

.total-due {
  background-color: #343a40 !important;
  color: white !important;
}
</style>